module.exports = __webpack_public_path__ + "media/es-ist-ein-ros.d70e0803.mp3";